import React from "react";
import { Container } from "react-bootstrap";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";


ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


const COLORS = ['#FF6633', '#FFB399', '#FF33FF', '#FFFF99', '#00B3E6', 
'#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
'#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A', 
'#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
'#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC', 
'#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
'#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680', 
'#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
'#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3', 
'#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF'];

/*
This takes dataObjA and plots it. 
dataObjA is an array of objects, each object has xArray, yArray, xLabel, yLabel, color, step, dataLabel
In current use, dataObjA is an array of 2 objects. 
*/


// App Parent Component
const CFILinePlot = ({ dataObjA }) => {
    dataObjA = dataObjA.filter(function( element ) {
        return element !== undefined && element.xArray !== undefined;
     });

     function getMIN(dataObjAA) {
        if (!dataObjAA || dataObjAA.length === 0) return 0;
        var minArray = [];
        for (var i = 0; i < dataObjAA.length; i++) {
            if (dataObjAA[i].yArray && dataObjAA[i].yArray.length > 0) {
                minArray.push(Math.min(...dataObjAA[i].yArray));
            }
        }
        if (minArray.length === 0) return 0;
        return Math.min(...minArray) - (dataObjAA[0].step || 0);
    }
    function getMAX(dataObjAA) {
        if (!dataObjAA || dataObjAA.length === 0) return 0;
        var maxArray = [];
        for (var i = 0; i < dataObjAA.length; i++) {
            if (dataObjAA[i].yArray && dataObjAA[i].yArray.length > 0) {
                maxArray.push(Math.max(...dataObjAA[i].yArray));
            }
        }
        if (maxArray.length === 0) return 0;
        return Math.max(...maxArray) + (dataObjAA[0].step || 0);
    }


    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
            },
            title: {
                display: true,
                text: "Flow dynamics results",
            },
        },
        scales: {
            x: {
                title: {
                    display: false,
                    text: dataObjA[0]?.xLabel || '',
                },
                ticks: {
                    display: false,
                },
                display: false,
            },
            y: {
                title: {
                    display: true,
                    text: dataObjA[0]?.yLabel || '',
                },
                min: getMIN(dataObjA),
                max: getMAX(dataObjA),
                stepSize: dataObjA[0]?.step || 1,
            },
            secondXAxis: {
                axis: "x",
                labels: ["GRAFT-PROXIMAL", "ANASTOMOSIS", "NATIVE-DISTAL"],
                grid: {
                    drawOnChartArea: false,
                },
            },
        },                
        elements: {
          point:{
              radius: 0
          }
        }
    };

    //   const isGraft = (ctx, value) => (ctx.p0.parsed.x < ((xArray.length-1) / 2) ? value : undefined);
    const datasets = [];
    let colorIndex = 0;

    for (const [index, iData] of Object.entries(dataObjA)) {
        const iDataset = {};
        iDataset.label = iData.dataLabel;
        iDataset.data = iData.yArray;
        iDataset.borderColor = iData.color || COLORS[colorIndex % COLORS.length];
        iDataset.backgroundColor = "rgba(255, 255, 255, 1)";
        datasets.push(iDataset);
        colorIndex++;
    }

    const data = {
        labels: dataObjA[0]?.xArray || [],
        datasets: datasets
    };
    return (
        <Container>
            <Line options={options} data={data} />
        </Container>
    );
};

export default CFILinePlot;
